/*******************************************************************************
GET TAB SETTINGS
Gather all the settings related to a tab.
*******************************************************************************/

export default function getTabSettings(tabSetName, tabName) {

    const $tab = $(`.toggle-tabs[data-name="${tabSetName}"]`).find(`.toggle-tab[data-name="${tabName}"]`);

    return {
        set    : tabSetName,
        name   : tabName,
        targets: ($tab.data('targets') || '').split('|'),
        add    : ($tab.data('add') || '').split('|'),
        remove : ($tab.data('remove') || '').split('|'),
    };
}
